export const EDITOR_CONTEXT_SET = 'EDITOR_CONTEXT_SET';
export const EDITOR_CONTEXT_REMOVE = 'EDITOR_CONTEXT_REMOVE';

export enum EditorContextName {
    markdown = 'markdown',
}
